<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <template v-if="form.elements">
            <div
                class="sm:col-span-12"
                v-for="(element, index) in form.elements"
                :key="`${index}_${form.correct_answer_index}`"
            >
                <div class="mt-1">
                    <div class="flex justify-between items-center">
                        <FormLabel :value="index + 1" :for="`element_${index}`" class="pr-2" />
                        <FormInput
                            required
                            :id="`element_${index}`"
                            v-model="element.text"
                            :name="`element_${index}`"
                            type="text"
                            maxlength="255"
                            class="mt-1 w-full"
                        />
                        <button
                            type="button"
                            @click="deleteOption(form.elements, index)"
                            v-show="index > 1"
                            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                <path
                                    fill-rule="evenodd"
                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <FormError :value="errors[`options.elements.${index}.text`]" class="mt-2" />
                </div>
            </div>

            <div v-show="form.elements.length < 10">
                <PlusButton @click="addOption()" />
            </div>
        </template>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';

export default {
    name: 'QuestionOrderElementsOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
        PlusButton,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {
        deleteOption(elements, index) {
            elements.splice(index, 1);
        },
        addOption() {
            this.form.elements.push({
                text: '',
            });
        },
    },
    mounted() {
        let defaultOptions = {
            correct_answer_index: 0,
            randomize_options: false,
            elements: [{ text: '' }, { text: '' }, { text: '' }, { text: '' }],
        };
        if (!this.form.hasOwnProperty('elements')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
